import cleanAssign from "@/clean-assign";
import {computed, reactive} from "vue";
import parseJson from "../parse-json";
import {BackendFetch} from "@hantera/portal-app";

interface Channels {
  [channelId: string]: {
    name: string
    inventories: {
      inventoryExternalId: string
      inventoryId: string
    }[]
  }
};

const channels = reactive<Channels>({});

export default function (portalFetch: BackendFetch) {

  return {

    /**
     * Returns a reactive string containing the channel name based on user's language
     * @param channelId 
     */
    getName(channelId: string) {
      return computed(() => {
        return channels[channelId]?.name
      })
    },

    /**
     * A reactive object containing the channels
     */
    value: channels,

    /**
     * Refreshes the tag definitions from server
     */
    async refresh() {

      // TODO Implement support for overriding language as user
      const browserLanguage = navigator.language.substring(0, 2);

      const res = await portalFetch('/legacy-channels/' + browserLanguage, {
        method: 'GET',
      });

      if (res.ok) {
        cleanAssign(channels, parseJson(await res.text()));
      }
    },

  };

}